export const isLoginCheck = () => {
    // console.log(localStorage.getItem('userData'));
    if (localStorage.getItem('userData')) return true;
    return false;
}


// WEBPACK FOOTER //
// ./src/Middleware/Auth.js